import { Fund, NestedKeyOf } from "creso-core/types";

type Accessor = NestedKeyOf<Fund>;

export const fundInfoRowConfig: { label: string; accessor: Accessor }[] = [
  {
    label: "Risk",
    accessor: "risk_level",
  },
  {
    label: "AUM",
    accessor: "assets_under_management",
  },
  {
    label: "Inception Date",
    accessor: "inception_date",
  },
  {
    label: "Current NAV",
    accessor: "performance.nav",
  },
  {
    label: "Expense Ratio",
    accessor: "expense_ratio",
  },
  {
    label: "Category",
    accessor: "broad_category_group",
  },
];

export const historicalReturnsRowConfig: {
  label: string;
  accessor: Accessor;
}[] = [
  {
    label: "1M",
    accessor: "performance.return_1_month",
  },
  {
    label: "3M",
    accessor: "performance.return_3_month",
  },
  {
    label: "1Y",
    accessor: "performance.return_1_year",
  },
  {
    label: "3Y",
    accessor: "performance.return_3_year",
  },
  {
    label: "5Y",
    accessor: "performance.return_5_year",
  },
  {
    label: "10Y",
    accessor: "performance.return_10_year",
  },
];

export const riskMetricsRowConfig: {
  label: string;
  accessor: Accessor;
}[] = [
  {
    label: "Alpha",
    accessor: "performance.alpha_3_year",
  },
  {
    label: "Beta",
    accessor: "performance.beta_3_year",
  },
  {
    label: "Sharpe Ratio",
    accessor: "performance.sharpe_ratio_3_year",
  },
  {
    label: "Sortino Ratio",
    accessor: "performance.sortino_ratio_3_year",
  },
  {
    label: "Standard Deviation",
    accessor: "performance.standard_deviation_3_year",
  },
];

export const assetAllocationRowConfig: {
  label: string;
  accessor?: string;
}[] = [
  {
    label: "Asset Allocation",
    accessor: "asset_allocation",
  },
  {
    label: "Aggregated allocation",
    accessor: "aggregated_allocation",
  },
];

export const sipCalculatorRowConfig: {
  label: string;
  accessor?: string;
}[] = [
  {
    label: "Total Investment",
    accessor: "total_invested",
  },
  {
    label: "Final Value",
    accessor: "portfolio_value",
  },
  {
    label: "XIRR",
    accessor: "cagr",
  },
  {
    label: "Standard deviation",
    accessor: "standard_deviation",
  },
  {
    label: "Max drawdown",
    accessor: "max_drawdown",
  },
];
